export const setDashboardInfos = (action) => async (dispatch, getState) => {
    dispatch({ type: 'SET_DASHBOARD_INFOS', data: action });
    return Promise.resolve();
};

export const setLoginAsData = (loginAsData) => async (dispatch, getState) => {
    dispatch({ type: 'SET_LOGIN_AS_DATA', data: loginAsData });
    return Promise.resolve();
};